import {
  http,
} from "./http.js";

async function getDistrict(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    region: {
      id: response.data.Region.Id,
      title: response.data.Region.Title,
      inputLanguage: response.data.Region.InputLanguage,
    },
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function updateDistrict(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function createDistrict(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`, {
      value: !entity.isRemoved,
    },
  );
  return response;
}

async function removeDistrict(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

async function getDistrictReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    region: {
      id: response.data.Region.Id,
      title: response.data.Region.Title,
    },
  };
}

async function fetchAllDistricts(resource, queryParams) {
  const response = await http.get(`${resource}/referencies?${queryParams}`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      country: i.Country ? {
        id: i.Country.Id,
        title: i.Country.Title,
        inputLanguage: i.Country.InputLanguage,
      } : null,
      region: i.Region ? {
        id: i.Region.Id,
        title: i.Region.Title,
      } : null,
    };
  });
}

async function getSearchReference(resource, search) {
  const response = await http.get(
    `${resource}/referencies?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
        country: {
          id: i.Country.Id,
          title: i.Country.Title,
          inputLanguage: i.Country.InputLanguage,
        },
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

export {
  getDistrict,
  updateDistrict,
  createDistrict,
  changeRemovedState,
  removeDistrict,
  getDistrictReference,
  fetchAllDistricts,
  getSearchReference,
};